import React, { FC } from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/** Компонент - желтая шапка */
export const CardDescription: FC<{
  bgColor?: string;
  color?: string;
  image?: string;
  label: string;
}> = ({ label, image, bgColor, color }) => {
  const stylesBlock = {
    ...(bgColor ? { backgroundColor: bgColor } : {}),
    ...(color ? { color } : {}),
  };
  return (
    <div className={cx('component')} style={stylesBlock}>
      <Text color={color} variant="body-small">
        {label}
      </Text>
      {image && (
        <div className={cx('image')}>
          <img alt="" src={image} />
        </div>
      )}
    </div>
  );
};
